import template from './mx-app.component.html';

export const MxAppComponent = {
	template: template,
	controllerAs: 'vm',
};
